const SLICE_NAME = 'aiSuggestions';

export { SLICE_NAME };
